import Aos from 'aos';
import 'aos/dist/aos.css';
import { Container, Title, createStyles } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { useEffect } from 'react';
const useStyle = createStyles((theme) => ({
  carousel: {
    '@media (max-width: 600px)': {
      height: 300,
    },
  },
  container: {
    width: 'auto',
    height: 150,
    textAlign: 'center',
    padding: 0,
    '@media (max-width: 600px)': {
      height: 250,
      marginTop: 0,
    },
  },
  image: {
    width: 'auto',
    height: '100%',
  },
}));
const PartnersMobileCompo = () => {
  const { classes } = useStyle();
  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });
  }, []);
  return (
    // <div className="row">
    //   <Carousel
    //     className={classes.carouselPartners1}
    //     withControls={true}
    //     controlSize={40}
    //     height={200}
    //     dragFree
    //     //slideSize="33.333333%"
    //     slideSize="20%"
    //     slideGap={20}
    //     mb={20}
    //     loop
    //     align="start"
    //     slidesToScroll={3}
    //     // plugins={[autoplay.current]}
    //     // onMouseEnter={autoplay.current.stop}
    //     // onMouseLeave={autoplay.current.reset}
    //     styles={{
    //       control: {
    //         '&[data-inactive]': {
    //           opacity: 0,
    //           cursor: 'default',
    //         },
    //       },
    //     }}
    //   >
    //     <div className="col">
    //       <Carousel.Slide>
    //         <Container className={classes.container}>
    //           <img
    //             src={require('../../assets/images/logo/potraitlogo/potrait1.jpg')}
    //             alt=""
    //             className={classes.image}
    //           />
    //         </Container>
    //       </Carousel.Slide>
    //     </div>
    //     <div className="col">
    //       <Carousel.Slide>
    //         <Container className={classes.container}>
    //           <img
    //             src={require('../../assets/images/logo/potraitlogo/potrait3.jpg')}
    //             alt=""
    //             className={classes.image}
    //           />
    //         </Container>
    //       </Carousel.Slide>
    //     </div>
    //     <div className="col">
    //       <Carousel.Slide>
    //         <Container className={classes.container}>
    //           <img
    //             src={require('../../assets/images/logo/potraitlogo/potrait2.jpeg')}
    //             alt=""
    //             className={classes.image}
    //           />
    //         </Container>
    //       </Carousel.Slide>
    //     </div>
    //     <div className="col">
    //       <Carousel.Slide>
    //         <Container className={classes.container}>
    //           <img
    //             src={require('../../assets/images/logo/potraitlogo/potrait4.jpeg')}
    //             alt=""
    //             className={classes.image}
    //           />
    //         </Container>
    //       </Carousel.Slide>
    //     </div>
    //     <div className="col">
    //       <Carousel.Slide>
    //         <Container className={classes.container}>
    //           <img
    //             src={require('../../assets/images/logo/potraitlogo/potrait5.jpeg')}
    //             alt=""
    //             className={classes.image}
    //           />
    //         </Container>
    //       </Carousel.Slide>
    //     </div>
    //     <div className="col">
    //       <Carousel.Slide>
    //         <Container className={classes.container}>
    //           <img
    //             src={require('../../assets/images/logo/potraitlogo/potrait6.jpeg')}
    //             alt=""
    //             className={classes.image}
    //           />
    //         </Container>
    //       </Carousel.Slide>
    //     </div>
    //     <div className="col">
    //       <Carousel.Slide>
    //         <Container className={classes.container}>
    //           <img
    //             src={require('../../assets/images/logo/potraitlogo/potrait7.jpeg')}
    //             alt=""
    //             className={classes.image}
    //           />
    //         </Container>
    //       </Carousel.Slide>
    //     </div>
    //   </Carousel>
    // </div>
    <div className="row">
      <Carousel
        height={200}
        withControls={true}
        controlSize={40}
        controlsOffset={50}
        slideSize="33.333333%"
        slideGap="md"
        loop
        dragFree
        align="center"
        slidesToScroll={1}
        className={classes.carousel}
        breakpoints={[
          { maxWidth: 'md', slideSize: '50%' },
          { maxWidth: 'sm', slideSize: '30%', slideGap: 50, slidesToScroll: 3 },
        ]}
        styles={{
          control: {
            backgroundColor: '#F2EEC8',
            color: '#F56600',
            borderColor: '#F2EEC8',
          },
        }}
      >
        {/* <Carousel.Slide>
          <Container className={classes.container}>
            <img
              src={require('../../assets/images/logo/potraitlogo/potrait2.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape1.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape2.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container}>
            <img
              src={require('../../assets/images/logo/potraitlogo/potrait5.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container}>
            <img
              src={require('../../assets/images/logo/potraitlogo/potrait2.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container}>
            <img
              src={require('../../assets/images/logo/potraitlogo/potrait2.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide> */}
        <div className="col">
          <Carousel.Slide>
            <Container className={classes.container}>
              <img
                src={require('../../assets/images/logo/potraitlogo/potrait1.jpg')}
                alt=""
                className={classes.image}
              />
            </Container>
          </Carousel.Slide>
        </div>
        <div className="col">
          <Carousel.Slide>
            <Container className={classes.container}>
              <img
                src={require('../../assets/images/logo/potraitlogo/potrait3.jpg')}
                alt=""
                className={classes.image}
              />
            </Container>
          </Carousel.Slide>
        </div>
        <div className="col">
          <Carousel.Slide>
            <Container className={classes.container}>
              <img
                src={require('../../assets/images/logo/potraitlogo/potrait2.jpeg')}
                alt=""
                className={classes.image}
              />
            </Container>
          </Carousel.Slide>
        </div>
        <div className="col">
          <Carousel.Slide>
            <Container className={classes.container}>
              <img
                src={require('../../assets/images/logo/potraitlogo/potrait4.jpeg')}
                alt=""
                className={classes.image}
              />
            </Container>
          </Carousel.Slide>
        </div>
        <div className="col">
          <Carousel.Slide>
            <Container className={classes.container}>
              <img
                src={require('../../assets/images/logo/potraitlogo/potrait5.jpeg')}
                alt=""
                className={classes.image}
              />
            </Container>
          </Carousel.Slide>
        </div>
        <div className="col">
          <Carousel.Slide>
            <Container className={classes.container}>
              <img
                src={require('../../assets/images/logo/potraitlogo/potrait6.jpeg')}
                alt=""
                className={classes.image}
              />
            </Container>
          </Carousel.Slide>
        </div>
        <div className="col">
          <Carousel.Slide>
            <Container className={classes.container}>
              <img
                src={require('../../assets/images/logo/potraitlogo/potrait7.jpeg')}
                alt=""
                className={classes.image}
              />
            </Container>
          </Carousel.Slide>
        </div>
      </Carousel>
    </div>
  );
};

export default PartnersMobileCompo;
